import { createMetricSender } from '@/src/metrics/send-metric';
import BottomSheetFenix from '@pedidosya/web-fenix/system/BottomSheet';
import ButtonFenix from '@pedidosya/web-fenix/system/Button';
import List from '@pedidosya/web-fenix/system/List';
import RowInteractiveL from '@pedidosya/web-fenix/system/RowInteractiveL';
import React, { useState } from 'react';

type Filters = {
  ranking: 'RANKING';
  distance: 'DISTANCE';
  deliveryTime: 'DELIVERY_TIME';
};

export type IFilter =
  | Filters['ranking']
  | Filters['distance']
  | Filters['deliveryTime']
  | unknown;

export interface IModalSorting {
  open: boolean;
  onClose: () => void;
  onClickHandler: () => void;
  setFilter: React.Dispatch<unknown>;
  filter: IFilter;
}

export const ModalSorting = (props: IModalSorting) => {
  const { open, onClose, onClickHandler, setFilter, filter } = props;

  const [sorting, setSorting] = useState<IFilter>('RANKING');
  const metricSender = createMetricSender();

  const handleClose = () => onClose();

  const handleApply = () => {
    setFilter(sorting);
    onClickHandler();
    handleClose();
  };

  return (
    <BottomSheetFenix
      onClose={handleClose}
      handler={false}
      onClickOut={handleClose}
      title="Ordenar"
      open={open}
    >
      <List
        collapsable={false}
        collapsed={false}
        collapseRows={4}
        highlight={false}
        type="image"
      >
        <List.Row>
          <RowInteractiveL
            primaryLeftText="Nuestros sugeridos"
            ctaType="selectable"
            ctaSubtype="radio_button"
            ctaBooleanValue={sorting === 'RANKING'}
            onClick={() => {
              metricSender.onRankingFilterClick();
              setSorting('RANKING');
            }}
          />
        </List.Row>
        <List.Row>
          <RowInteractiveL
            primaryLeftText="Más cercanos"
            ctaType="selectable"
            ctaSubtype="radio_button"
            ctaBooleanValue={sorting === 'DISTANCE'}
            onClick={() => {
              metricSender.onDistanceFilterClick();
              setSorting('DISTANCE');
            }}
          />
        </List.Row>
        <List.Row>
          <RowInteractiveL
            primaryLeftText="Más rápidos"
            ctaType="selectable"
            ctaSubtype="radio_button"
            ctaBooleanValue={sorting === 'DELIVERY_TIME'}
            onClick={() => {
              metricSender.onDeliveryTimeFilterClick();
              setSorting('DELIVERY_TIME');
            }}
          />
        </List.Row>
        <List.Row>
          <div style={{ padding: '0 16px 36px 16px' }}>
            <ButtonFenix
              label="Aplicar"
              size="large"
              data-testid="apply-sorting"
              fullWidth
              onClick={handleApply}
              state={filter === sorting ? 'disabled' : 'enabled'}
            />
          </div>
        </List.Row>
      </List>
    </BottomSheetFenix>
  );
};
